import type { Coverage } from '@medplum/fhirtypes'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useMiddlewareClient } from '@/hooks'
import { normalizeResolvedCoverageSlots } from '@/utils/coverageUtils'

type ResolvedCoveragesResult = {
  patientId: string
  mode: 'hg' | 'local-only'
  primary?: Coverage
  secondary?: Coverage
  tertiary?: Coverage
}

type MiddlewareGetClient = {
  get: <T = unknown>(url: string) => Promise<{ result: T }>
}

export const visitPatientCoverageQueryKey = (patientId: string) =>
  ['visit-patient-coverage', { patientId }] as const

export async function fetchVisitPatientCoveragesNormalized(
  middleware: MiddlewareGetClient,
  patientId: string,
) {
  const { result } = await middleware.get<ResolvedCoveragesResult>(
    `/insurance/patient/${patientId}/coverages`,
  )

  return normalizeResolvedCoverageSlots(result)
}

export function usePatientCoverage(patientId: string) {
  const middleware = useMiddlewareClient()
  const middlewareClient = middleware as unknown as MiddlewareGetClient

  return useSuspenseQuery({
    queryKey: visitPatientCoverageQueryKey(patientId),
    staleTime: 1000 * 60 * 60,
    queryFn: () => fetchVisitPatientCoveragesNormalized(middlewareClient, patientId),
  })
}
